import { Breakpoints, Container, ContainerGutter, ContainerPadding, ControlContainer, FullscreenButton, Layout, PlayButton, PlayButtonCenter, styled, Text, TextAlignment, TextTag, TimeDisplay, Timeline, TokenTextAppearance, Video, VolumeSlider } from "@volkswagen-onehub/components-core";
import React from "react";
const VideoContainer = styled.div`
	display: flex;
	justify-content: center;
	> div {
		width: 100%;
		max-width: 1440px;
	}
`;
const StyledPlayButton = styled.div `
	button {
		transition: 200ms;
		background-color: var(--c-red);
		&:hover {
			background-color: var(--c-white) !important;
			svg {
				color: var(--c-red) !important;
			}
		}
	}
`;

export function VideoSection() {
	return (
		<React.Fragment>
			<Layout appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 2 },
					{ name: 'video', columns: 20 },
					{ name: '.', columns: 2 }
				]
			}}>
				<Container wrap="always" gutter={ContainerGutter.dynamic0250} padding={{top: ContainerPadding.dynamic0350}}>
					<Text
						tag={TextTag.h2} appearance={ TokenTextAppearance.headline500 } bold
						textAlign={ TextAlignment.center }
					>
						Adivina quién piensa que mereces carbón.{ window.innerWidth > Breakpoints.b960 && <br /> } Y dale las gracias
					</Text>
					<VideoContainer>
						<Video src="https://assets.volkswagen.com/is/content/volkswagenag/2VW-GTI-Negro-Carbon-30sg-cas-v2-0x720-3000k">
							<StyledPlayButton>
								<PlayButtonCenter playTitle="first-play" />
							</StyledPlayButton>
							<ControlContainer hideInitially>
								<PlayButton playTitle="Play video" pauseTitle="Pause video" />
								<Timeline />
								<TimeDisplay />
								<VolumeSlider muteTitle="Mute video" unmuteTitle="Unmute video" />
								<FullscreenButton openTitle="Open video in fullscreen" closeTitle="Close fullscreen" />
							</ControlContainer>
						</Video>
					</VideoContainer>
				</Container>
			</Layout>
		</React.Fragment>
	);
}